/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function UsersIcon({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <g clipPath="url(#clip0_1331_38973)">
                <path d="M4.70332 7.13158C6.44302 7.13158 7.85332 5.64705 7.85332 3.81579C7.85332 1.98453 6.44302 0.5 4.70332 0.5C2.96362 0.5 1.55332 1.98453 1.55332 3.81579C1.55332 5.64705 2.96362 7.13158 4.70332 7.13158Z" fill="currentColor" />
                <path d="M5.75332 7.86842H3.65332C2.7254 7.86959 1.83581 8.25812 1.17967 8.94879C0.523538 9.63946 0.154432 10.5759 0.15332 11.5526V13.7632C0.15332 13.9586 0.22707 14.146 0.358346 14.2842C0.489621 14.4224 0.667669 14.5 0.85332 14.5H8.55332C8.73897 14.5 8.91702 14.4224 9.0483 14.2842C9.17957 14.146 9.25332 13.9586 9.25332 13.7632V11.5526C9.25221 10.5759 8.8831 9.63946 8.22697 8.94879C7.57083 8.25812 6.68124 7.86959 5.75332 7.86842Z" fill="currentColor" />
                <path d="M7.27162 5.72273C7.64917 5.16621 7.8525 4.49964 7.85332 3.81579C7.85182 3.57299 7.82506 3.33109 7.77352 3.09442C7.48844 3.4538 7.2932 3.88248 7.20555 4.3415C7.1179 4.80051 7.14061 5.27531 7.27162 5.72273Z" fill="currentColor" />
                <path d="M9.95332 1.97368C9.61804 1.97638 9.28601 2.04304 8.97332 2.17042C9.26125 2.98619 9.33041 3.86961 9.17324 4.72399C9.01607 5.57837 8.63862 6.37076 8.08222 7.01442C8.3962 7.19763 8.6903 7.41629 8.95932 7.66653C9.27607 7.7975 9.61302 7.86594 9.95332 7.86842C10.6959 7.86842 11.4081 7.5579 11.9332 7.00516C12.4583 6.45242 12.7533 5.70274 12.7533 4.92105C12.7533 4.13936 12.4583 3.38969 11.9332 2.83695C11.4081 2.28421 10.6959 1.97368 9.95332 1.97368Z" fill="currentColor" />
                <path d="M10.6533 8.60526H9.75942C10.3394 9.46699 10.6516 10.4966 10.6533 11.5526V13.7632C10.6511 14.0148 10.6075 14.264 10.5245 14.5H13.4533C13.639 14.5 13.817 14.4224 13.9483 14.2842C14.0796 14.146 14.1533 13.9586 14.1533 13.7632V12.2895C14.1522 11.3127 13.7831 10.3763 13.127 9.68564C12.4708 8.99497 11.5812 8.60643 10.6533 8.60526Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_1331_38973">
                    <rect width="14" height="14" fill="white" transform="translate(0.15332 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
